export const customer = (customer)  => {
    const errors = { customer:{} }
    let isValid = true
    // if(!customer.name) {
    //     isValid = false
    //     errors.name = 'Please insert name'
    // }
    // if(customer.phone.length !== 8) {
    //     isValid = false
    //     errors.phone = 'The phone number must be 8 characters.'
    // }
    if(!customer.phone) {
        isValid = false
        errors.phone = 'Please insert phone'
    }
    // if(!customer.address) {
    //     isValid = false
    //     errors.address = 'Please insert address'
    // }
    return {isValid, errors}
  }
